module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="user-text-wrapper" style="display:none">' +
((__t = ( submitterAnchor(true) )) == null ? '' : __t) +
' ';
 if(collect_method && (collect_method.indexOf('hashtag') != -1 || collect_method.indexOf('handle') != -1) && collect_term){ ;
__p += '| ' +
((__t = ( collect_term  )) == null ? '' : __t) +
' ';
 };
__p += '</div>';

}
return __p
}